import * as R from "ramda";
import { FREQUENCY_IDS } from "./constants/dimensions.mjs";
const setParam = (param) => R.assoc(param.key, param.value);
const isFrequency = R.pipe(
  R.prop("id"),
  R.flip(R.includes)(FREQUENCY_IDS)
);
const cartesian = R.reduce(
  (acc, array) => R.unnest(R.map((x) => R.map((y) => R.append(y, x), array), acc)),
  [[]]
);
export {
  cartesian,
  isFrequency,
  setParam
};
